import React from 'react';
import classnames from 'classnames';

import userIcon from 'public/static/images/userIcon.svg';
import { colors } from 'components/styles/variables';

export interface ReviewerInfoProps {
  reviewerName: string;
  bestLocationDisplayName: string;
  className?: string;
}

export default function ReviewerInfo(props: ReviewerInfoProps): JSX.Element {
  return (
    <>
      <div className={classnames('reviewer', props.className)} data-testid="reviewer-container">
        <img className="reviewer-icon" src={userIcon} alt={props.reviewerName} />
        <div className="reviewer-info">
          <div className="reviewer-name">{props.reviewerName}</div>
          <div className="reviewer-location">{props.bestLocationDisplayName}</div>
        </div>
      </div>

      <style jsx>{`
        .reviewer {
          display: flex;
          flex-direction: row;
          padding-bottom: 16px;
        }

        .reviewer-icon {
          height: 38px;
          width: 38px;
          margin-right: 14px;
        }

        .reviewer-name {
          font-weight: 700;
          font-size: 18px;
          line-height: 26px;
          letter-spacing: 0.2px;
          color: ${colors.BLACK};
        }

        .reviewer-location {
          font-weight: 400;
          font-size: 14px;
          line-height: 18px;
          letter-spacing: 0.2px;
          color: ${colors.BLACK};
        }
      `}</style>
    </>
  );
}
